<template>
  <div>
    <div class="row justify-content-between align-items-end border-bottom pb-3">
      <div class="col">
        <TitleBreadcrumb :page="page" />
      </div>
      <div>
        <ActionButton
          id="program-service-back"
          i="fas fa-arrow-circle-left"
          variant="outline-success m-2"
          @click="$root.$router.push(`/pei/detail?tab=Tab4`)"
        >
          Regresar
        </ActionButton>
        <ActionButton
          v-if="programServiceAreaId && selectedArea && !isReadOnly"
          variant="success mx-1"
          i="fas fa-file-plus"
          @click="goToAddProgramService()"
        >
          Añadir &Aacute;rea
        </ActionButton>
      </div>
    </div>

    <div class="my-3">
      <div class="d-flex justify-content-end">
        <div
          v-if="programServiceAreaId && canShowGoalsV2Switch"
          class="mr-3 d-flex justify-content-end toggle-position"
        >
          <custom-toggle id="goals-v2-switch" sync v-model="isGoalsV2Enabled" />
          <label class="ml-3">Nueva versión de Metas</label>
        </div>
        <div
          v-if="programServiceAreaId && canShowDesginerSwitch"
          class="d-flex justify-content-end toggle-position"
        >
          <custom-toggle
            id="goals-objectives-v2-switch"
            sync
            v-model="isGoalsAndObjectivesDesignerEnabled"
          />
          <label class="ml-3">Diseñador Metas y Objetivos</label>
        </div>
      </div>

      <SectionTitle :has-line="true" :content="sectionTitleContent" />
      <div v-if="programServiceAreaId && selectedArea" class="ml-3">
        <label class="d-flex font-14 color-black">
          Área que se desarrollará en el programa de servicio:
        </label>
        <label class="area-label">{{ selectedArea.name }}</label>
      </div>
      <div class="d-flex justify-content-end">
        <ActionButton
          i="fas fa-save"
          variant="success m-2"
          @click="saveActiveTab"
        >
          Guardar
        </ActionButton>
      </div>
    </div>

    <div class="ml-3">
      <ValidationObserver ref="addProgramServiceValidator">
        <form
          ref="addProgramServiceForm"
          class="main-content mt-2"
          novalidate
          @submit.prevent="saveProgramServiceArea"
        >
          <div class="row my-2">
            <div v-if="!programServiceAreaId" class="col-6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Area"
                rules="required"
              >
                <dropdown
                  id="selectAreaDD"
                  v-model="selectedArea"
                  placeholder="Seleccione"
                  label="Área que se desarrollará en el programa de servicio: "
                  required
                  fieldkey="id"
                  fieldname="name"
                  :options="areas"
                  :error="errors[0]"
                  :on-selection-change="cleanFields"
                  custom-error-msg="Favor de seleccionar un área"
                />
              </ValidationProvider>
            </div>

            <div v-if="!programServiceAreaId && !isPSC" class="col-4 pt-4">
              <ActionButton
                type="submit"
                i="fas fa-file-plus"
                variant="success m-2"
              >
                Añadir Área
              </ActionButton>
            </div>
          </div>

          <div v-if="showTeacherSelection" class="row">
            <div v-if="!programServiceAreaId" class="col-6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Teacher"
                rules="required"
              >
                <dropdown
                  id="selectTeacherDD"
                  v-model="selectedTeacher"
                  placeholder="Seleccione"
                  required
                  fieldkey="id"
                  fieldname="name"
                  label="Tipo de Maestro: "
                  :options="teachers"
                  :error="errors[0]"
                  custom-error-msg="Favor de seleccionar el tipo de maestro"
                />
              </ValidationProvider>
            </div>

            <div
              v-if="
                programServiceAreaId && (selectedTeacher || requiredTeacher)
              "
              class="col-6"
            >
              <div
                v-if="!editSelectionTeacher && !requiredTeacher"
                class="mb-2 action-div"
                title="Editar selección"
                @click="setValueMaster()"
              >
                <label class="d-flex font-14 color-black d-flex">
                  Tipo de Maestro:
                </label>
                <label class="area-label">{{ selectedTeacher.name }}</label>
              </div>
              <dropdown
                v-if="editSelectionTeacher || requiredTeacher"
                id="selectTeacherDD"
                v-model="selectedTeacher"
                placeholder="Tipo de Maestro: "
                required
                fieldkey="id"
                fieldname="name"
                prefix-text="Tipo de Maestro: "
                :options="teachers"
                custom-error-msg="Favor de seleccionar el tipo de maestro"
                @input="onEditTeacherDropdown"
              />
            </div>
          </div>

          <div v-if="showOthersTextArea" class="row">
            <div v-if="!programServiceAreaId" class="col-6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Otros"
                rules="required"
              >
                <custom-textarea
                  v-model="others"
                  required
                  :maxlength="maxlength"
                  :error="errors[0]"
                  custom-error-msg="Favor de entrar la descripción del área Otros"
                />
              </ValidationProvider>
            </div>

            <div
              v-if="programServiceAreaId && !editTextOthers"
              class="col-8 action-div"
              title="Editar texto"
              @click="editTextOthers = true"
            >
              <label class="area-label">{{ others }}</label>
            </div>

            <div v-if="programServiceAreaId && editTextOthers" class="col-6">
              <ValidationProvider
                v-slot="{ errors }"
                name="Otros"
                rules="required"
              >
                <custom-textarea
                  v-model="others"
                  required
                  :maxlength="maxlength"
                  :error="errors[0]"
                  custom-error-msg="Favor de entrar la descripción del área Otros"
                />
              </ValidationProvider>
              <div class="d-flex justify-content-end">
                <ActionButton
                  type="button"
                  i="fas fa-save"
                  variant="success m-2"
                  @click="saveTextOthers"
                >
                  Guardar
                </ActionButton>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <q-tab
      v-if="showTabs && programServiceAreaId"
      :tabActivated="handleSwitchTab"
      ref="qTab"
    >
      <q-tab-item
        title="Resumen de Resultado"
        v-if="tempViewer || showResultSummary"
        lazy
        :active="activeTab == tabs.ResumenResultados"
        :tabindex="tabs.ResumenResultados"
        :has-error="
          validator.hasResultSummarySectionError(programServiceAreaId)
        "
      >
        <result-summary
          :ref="tabRefs[tabs.ResumenResultados]"
          :student-sie="pei.studentSieId"
          :academic-year-id="pei.configAcademicYearId"
          :discipline-type-id="selectedArea?.value"
          :discipline-name="selectedArea?.name"
          :program-service-area-id="programServiceAreaId"
          :pei-id="pei.peiId"
          :admission-status-id="referralAdmissionInfo?.admissionStatusId"
          :result-summary-document="
            referralAdmissionInfo?.summaryResultDocument
          "
          :has-result-summary="hasResultSummary"
          :read-only="isReadOnly"
          @pending-changes="setPendingChange"
        />
      </q-tab-item>
      <q-tab-item
        title="Sub Áreas"
        :active="activeTab == tabs.SubAreas"
        :tabindex="tabs.SubAreas"
        lazy
        :has-error="validator.hasSubAreaSectionError(programServiceAreaId)"
      >
        <SectionTitle :has-line="true" content="Sub Áreas" />
        <SubAreasSelection
          :ref="tabRefs[tabs.SubAreas]"
          :area-id="selectedArea?.id"
          :program-service-area-id="programServiceAreaId"
          :has-error="validator.hasSubAreaSectionError(programServiceAreaId)"
          :read-only="isReadOnly"
          @pending-changes="setPendingChange"
        />
      </q-tab-item>
      <q-tab-item
        title="Fortalezas"
        lazy
        v-if="!this.isGoalsAndObjectivesDesignerEnabled"
        :active="activeTab == tabs.Fortalezas"
        :tabindex="tabs.Fortalezas"
        :has-error="validator.hasStrengthSectionError(programServiceAreaId)"
      >
        <StrenghtSelection
          :ref="tabRefs[tabs.Fortalezas]"
          :area-id="selectedArea?.id"
          :selected-area="selectedArea"
          :program-service-area-id="programServiceAreaId"
          :selected-pei-id="selectedPeiId"
          :pei="pei"
          :has-error="validator.hasStrengthSectionError(programServiceAreaId)"
          :read-only="isReadOnly"
          @pending-changes="setPendingChange"
        />
      </q-tab-item>
      <q-tab-item
        title="Necesidades"
        lazy
        v-if="!this.isGoalsAndObjectivesDesignerEnabled"
        :tabindex="tabs.Necesidades"
        :active="activeTab == tabs.Necesidades"
        :has-error="validator.hasNecessitySectionError(programServiceAreaId)"
      >
        <NecessitiesSelection
          :ref="tabRefs[tabs.Necesidades]"
          :area-id="selectedArea?.id"
          :program-service-area-id="programServiceAreaId"
          :selected-pei-id="selectedPeiId"
          :pei="pei"
          :has-error="validator.hasNecessitySectionError(programServiceAreaId)"
          :read-only="isReadOnly"
          @pending-changes="setPendingChange"
        />
      </q-tab-item>
      <q-tab-item
        title="Información de Fortalezas y Necesidades"
        lazy
        v-if="this.isGoalsAndObjectivesDesignerEnabled"
        :tabindex="tabs.FortalezasNecesidades"
        :active="activeTab == tabs.FortalezasNecesidades"
        :has-error="
          validator.hasSkillSectionError(programServiceAreaId) ||
            validator.hasLevelSectionError(programServiceAreaId)
        "
      >
        <StrengthNecessitiesSelection
          :ref="tabRefs[tabs.FortalezasNecesidades]"
          :area-id="selectedArea?.id"
          :program-service-area-id="programServiceAreaId"
          :selected-pei-id="selectedPeiId"
          :pei="pei"
          :has-error="validator.hasSkillSectionError(programServiceAreaId)"
          :has-level-error="validator.hasLevelSectionError(programServiceAreaId)"
          :read-only="isReadOnly"
          :is-goal-levels-enabled="isGoalLevelsEnabled"
          @pending-changes="setPendingChange"
        />
      </q-tab-item>
      <q-tab-item
        title="Procedimientos"
        lazy
        :tabindex="tabs.Procedimientos"
        :active="activeTab == tabs.Procedimientos"
        :has-error="validator.hasProcedureSectionError(programServiceAreaId)"
      >
        <ProceduresSelection
          :ref="tabRefs[tabs.Procedimientos]"
          :program-service-area-id="programServiceAreaId"
          :has-error="validator.hasProcedureSectionError(programServiceAreaId)"
          :read-only="isReadOnly"
          @pending-changes="setPendingChange"
        />
      </q-tab-item>
      <q-tab-item
        :title="goalsTitle"
        lazy
        v-if="!isGoalsAndObjectivesDesignerEnabled"
        :active="activeTab == tabs.MetasObjetivos"
        :tabindex="tabs.MetasObjetivos"
        :has-error="validator.hasGoalSectionError(programServiceAreaId)"
      >
        <GoalsList
          :ref="tabRefs[tabs.MetasObjetivos]"
          :pei-id="selectedPeiId"
          :area-id="selectedArea?.id"
          :service-area-id="programServiceAreaId"
          :necessity-options="necessitiesAndStrength"
          :sub-area-options="subAreasOptions"
          :has-error="validator.hasGoalSectionError(programServiceAreaId)"
          :min-required-goals="validator.minGoalsRequired(programServiceAreaId)"
          :skills-required="isY2024_2025 && !isTherapy"
          :read-only="isReadOnly"
          :show-objetives-section="showObjetivesSection"
          :adequacy-options="adequacyOptions"
          :show-adequacy="showAdequacy"
          @create-goal="handleCreateGoal"
          @delete-goal="handleDeleteGoal"
          @update-goal="handleUpdateGoal"
          @add-objetive="handleAddObjetive"
          @delete-objetive="handleDeleteObjetive"
          @delete-goal-necessity="handleDeleteGoalNecessity"
          @pending-changes="setPendingChange"
        />
      </q-tab-item>
      <q-tab-item
        :title="goalsTitle"
        v-if="isGoalsAndObjectivesDesignerEnabled"
        lazy
        :tabindex="tabs.MetasObjetivosV2"
        :active="activeTab == tabs.MetasObjetivosV2"
        :has-error="validator.hasGoalSectionError(programServiceAreaId)"
      >
        <GoalsManagerV2
          :ref="tabRefs[tabs.MetasObjetivosV2]"
          :area-id="selectedArea?.id"
          :goals="createdGoals"
          :sub-area-options="subAreasOptions"
          :necessity-options="necessitiesAndStrength"
          :term-options="termOptions"
          :suitability-options="suitabilityOptions"
          :adequacy-options="adequacyOptions"
          :show-adequacy="showAdequacy"
          :instrument-options="instrumentOptions"
          :has-error="validator.hasGoalSectionError(programServiceAreaId)"
          :min-required-goals="validator.minGoalsRequired(programServiceAreaId)"
          :is-read-only="isReadOnly"
          :skills-required="isY2024_2025 && !isTherapy"
          :show-objetives-section="showObjetivesSection"
          :ai-assistant-enabled="aiAssistantEnabled"
          @create-goal="handleCreateGoal"
          @add-objetive="handleAddObjetive"
          @delete-goal="handleDeleteGoal"
          @update-goal="handleUpdateGoal"
          @update-objetive="handleUpdateObjetive"
          @delete-objetive="handleDeleteObjetive"
          @delete-goal-necessity="handleDeleteGoalNecessity"
          @update-skills="handleUpdateSkills"
          @pending-changes="setPendingChange"
        />
      </q-tab-item>
      <q-tab-item
        v-if="showServiceCompensatory"
        title="Servicios Compensatorios"
        lazy
        :tabindex="tabs.ServiciosCompensatorios"
        :active="activeTab == tabs.ServiciosCompensatorios"
        :has-error="hasServiceCompensationError"
      >
        <ServiceCompensationTab
          :ref="tabRefs[tabs.ServiciosCompensatorios]"
          :sie="pei.studentSieId"
          :pei-id="selectedPeiId"
          :is-pei-complete="isComplete"
          :can-show-validation="canShowValidationCompensatory"
          :program-service-area-id="programServiceAreaId"
          :disciplineTypeId="selectedArea?.value"
          :read-only="isReadOnly"
          :has-error="hasServiceCompensationError"
          @pending-changes="setPendingChange"
        />
      </q-tab-item>
    </q-tab>
  </div>
</template>

<script>
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import { SectionTitle } from '@/components/pei/shared';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { commonValues } from '@/utils/constants/at/common';
import Dropdown from '@/components/common/CustomDropDown';
import CustomTextarea from '@/components/common/CustomTextArea';
import ActionButton from '@/components/common/ActionButton';
import GoalsList from '@/components/pei/programservice/goals/GoalsList.vue';
import SubAreasSelection from '@/components/pei/programservice/SubAreasSelection';
import StrenghtSelection from '@/components/pei/programservice/StrenghtSelection';
import ProceduresSelection from '@/components/pei/programservice/ProceduresSelection';
import store from '@/store/index';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';
import NecessitiesSelection from '@/components/pei/programservice/NecessitiesSelection';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import { CustomToggle } from '@/components/common';
import StrengthNecessitiesSelection from './StrengthNecessitiesSelection';
import ServiceCompensationTab from './tabs/ServiceCompensationTab.vue';
import GoalsManagerV2 from './v2/GoalsManager';
import types from '@/modules/user/store/types';
import {
  updateGoalsObjectivesFlag,
  updateGoalsV2Flag,
} from '@/modules/user/api';
import ResultSummary from './components/ResultSummary.vue';
import { getStudentReferralAdmissionInfo as _getStudentReferralAdmissionInfo } from '@/modules/referral/api';
import admissionStatus from '@/utils/constants/pei/referral/admissionStatus.js';
import thrpiesServiceCode from '@/utils/constants/thpiesService.js';
import academicYears from '@/utils/constants/academicYears';
import peiStatusEnum from '@/utils/constants/pei/peiStatus.js';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import TabAliasEnum from './enum/TabAliasEnum';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';

import { createNamespacedHelpers } from 'vuex';
import { modulesName } from '@/modules';
const { mapActions, mapState, mapGetters } = createNamespacedHelpers(
  modulesName.programServiceModuleName
);

const TABS = {
  ResumenResultados: 1,
  SubAreas: 2,
  Fortalezas: 3,
  Necesidades: 4,
  FortalezasNecesidades: 5,
  MetasObjetivos: 6,
  MetasObjetivosV2: 7,
  ServiciosCompensatorios: 8,
  Procedimientos: 9,
};

let initialState = () => ({
  page: {
    icon: 'fas fa-user-edit',
    title: 'IV-V. Programa de Servicios',
    routes: ['Inicio', 'PEI', 'Programa de Servicio'],
  },
  maxlength: 3000,
  areas: [],
  allAreas: null,
  teachers: [],
  selectedArea: null,
  selectedTeacher: null,
  others: '',
  submittedAreaId: null,
  selectedPeiId: store.getters.SelectedPei,
  pei: {},
  editSelectionTeacher: false,
  editTextOthers: false,
  isGoalsV2Enabled: false,
  isGoalsAndObjectivesDesignerEnabled: false,
  // AG-05 -- "Objetivo con Asistente IA": mismo sysparam EnableAiAssistantPei que ya usa
  // Tab3.vue en III-A/III-B, reutilizado aquí (no se crea un parámetro nuevo por feature).
  aiAssistantParamEnabled: false,
  activeTab: null,
  referralAdmissionInfo: null,
  canShowValidationCompensatory: false,
  tabs: TABS,
  tabPendingChanges: [],
  tabRefs: [],
  showTabs: true,
  tempViewer: true,
  showObjetivesSectionInTherapy: true,
  showObjetivesSectionInNonTherapy: true,
  showAdequacy: false,
  isGoalLevelsEnabled: false,
});

const DEFAULT_MESSAGE_ERROR = 'Ocurrio un problema inesperado';

export default {
  name: 'AddProgramService',
  mixins: [alert],
  components: {
    TitleBreadcrumb,
    ServiceCompensationTab,
    SectionTitle,
    CustomCollapse,
    CustomCollapseItem,
    Dropdown,
    CustomTextarea,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    GoalsList,
    SubAreasSelection,
    StrenghtSelection,
    NecessitiesSelection,
    ProceduresSelection,
    CustomToggle,
    StrengthNecessitiesSelection,
    GoalsManagerV2,
    ResultSummary,
    QTab,
    QTabItem,
  },
  data: () => initialState(),
  computed: {
    ...mapState(['createdGoals', 'selectedStrengthsNecessities']),
    ...mapGetters([
      'resource',
      'termOptions',
      'suitabilityOptions',
      'instrumentOptions',
      'adequacyOptions',
      'subAreasOptions',
      'canShowSummaryResultParam',
      'canShowCompensatoryServicesInPeiParam',
    ]),
    validator() {
      return store.getters.tab4Validator;
    },
    activeEducationalCompensatoryService() {
      return store.getters.activeEducationalCompensatoryService;
    },
    hasServiceCompensationError() {
      const hasCompletePeiError =
        !!this.programServiceAreaId &&
        this.validator.hasCompensationServiceInvalid(this.programServiceAreaId);
      const listTovalidateConst = store.state.compensatoryServicesValidation;

      return (
        listTovalidateConst.some(
          (obj) => obj.diciplineTypeId === this.selectedArea?.value
        ) || hasCompletePeiError
      );
    },
    necessitiesAndStrength() {
      return this.selectedStrengthsNecessities.map((x) => ({
        ...x,
        nameDetail: x.isStrength ? '[Fortaleza]' : '[Necesidad]',
      }));
    },
    hasResultSummary() {
      let admissionStatusesList = [
        admissionStatus.ServicioRelacionadoActivo,
        admissionStatus.NoVigenteAlta,
        admissionStatus.NoVigenteBajas,
        admissionStatus.Admitido,
        admissionStatus.Vinculado,
        admissionStatus.Asignado,
        admissionStatus.NoVigenteTraslado,
        admissionStatus.AprobadoRemedioProvisional,
        admissionStatus.NoVigenteCambioEnServicio,
        admissionStatus.NoVigenteCambioEnServicio,
        admissionStatus.NoVinculado,
        admissionStatus.NoVigenteEgreso,
      ];

      return !!(
        this.referralAdmissionInfo &&
        admissionStatusesList.includes(
          this.referralAdmissionInfo.admissionStatusId
        ) &&
        this.referralAdmissionInfo.isDisciplineTherapy &&
        this.canShowSummaryResultParam
      );
    },
    isComplete() {
      return (
        store.getters.SelectedPeiStatus == Number(peiStatusEnum.Completado)
      );
    },
    isReadOnly() {
      return (
        this.isComplete ||
        store.getters.SelectedPeiStatus == Number(peiStatusEnum.Firmado)
      );
    },
    // El asistente solo se ofrece con el parámetro activo, el PEI en Borrador y áreas que no son
    // terapia (en terapias no hay Sub Área ni Fortaleza/Necesidad, que V-Metas requiere).
    aiAssistantEnabled() {
      return (
        this.aiAssistantParamEnabled &&
        !this.isTherapyExcludingEducational &&
        store.getters.SelectedPeiStatus == Number(peiStatusEnum.Borrador)
      );
    },
    showTeacherSelection() {
      return this.selectedArea
        ? [
            commonValues.PROGRAM_AREAS.EDUCACION_FISICA_ADAPTADA,
            commonValues.PROGRAM_AREAS.SERVICIO_SORDOS,
            commonValues.PROGRAM_AREAS.SERVICIO_CIEGOS,
            commonValues.PROGRAM_AREAS.EDUCACION_FISICA_ADAPTADA_COMBINADA,
            commonValues.PROGRAM_AREAS.CONSEJERIA_REHABILITACION,
          ].includes(this.selectedArea?.id)
        : false;
    },
    requiredTeacher() {
      return (
        this.showTeacherSelection &&
        (this.selectedTeacher == null || this.selectedTeacher == undefined)
      );
    },
    showOthersTextArea() {
      return this.selectedArea
        ? this.selectedArea?.id === commonValues.PROGRAM_AREAS.OTROS
        : false;
    },
    programServiceAreaId() {
      return this.submittedAreaId || this.$root.$route.query.programservicearea;
    },
    tabRoute() {
      return this.$root.$route.query.tab ?? null;
    },
    sectionTitleContent() {
      return this.programServiceAreaId
        ? 'Programa de Servicios'
        : 'Añadir Programa de Servicios';
    },
    canShowGoalsV2Switch() {
      return this.userHasPermissions('pei.goalsnewversion');
    },
    canShowDesginerSwitch() {
      return this.userHasPermissions('pei.goalsandobjectivesnewversion');
    },
    isY2024_2025() {
      return this.pei.configAcademicYearId >= academicYears.Y2024_2025;
    },
    isTherapy() {
      return !this.selectedArea?.value
        ? false
        : this.serviceIsterapy(this.selectedArea.value);
    },
    // isTherapy también incluye las disciplinas educativas (Español, Matemáticas...); aquí se excluyen.
    isTherapyExcludingEducational() {
      return (
        this.isTherapy &&
        ![
          thrpiesServiceCode.Educativo,
          thrpiesServiceCode.TerapiaEducativa,
        ].includes(this.selectedArea.value)
      );
    },
    showResultSummary() {
      const result = this.isY2024_2025 && this.isTherapy;
      this.tempViewer = result;

      return result;
    },
    showServiceCompensatory() {
      return (
        !this.activeEducationalCompensatoryService &&
        this.canShowCompensatoryServicesInPeiParam &&
        this.isTherapy &&
        this.isY2024_2025
      );
    },
    showObjetivesSection() {
      if (this.isTherapy) {
        return this.showObjetivesSectionInTherapy;
      }

      return this.showObjetivesSectionInNonTherapy;
    },
    goalsTitle() {
      return this.showObjetivesSection ? 'Metas y Objetivos' : 'Metas';
    },
    isPSC() {
      return store.state.pei.configUnilateralFlag == '2';
    },
  },
  watch: {
    async isGoalsV2Enabled(newValue, oldValue) {
      this.showTabs = false;
      setTimeout(() => (this.showTabs = true), 100);

      if (oldValue == null) return;

      await this.saveGoalsV2Flag();
      await this.fetchGoalsSectionVisbility(
        this.selectedPeiId,
        this.isGoalsV2Enabled
      );
      this.reloadTabsData();
    },
    isGoalsAndObjectivesDesignerEnabled(newValue, oldValue) {
      this.showTabs = false;
      setTimeout(() => (this.showTabs = true), 100);

      if (oldValue == null) return;

      this.saveGoalsAndObjectivesFlag();
      this.reloadTabsData();
    },
    selectedArea: {
      deep: true,
      handler(newValue) {
        if (!newValue) return;

        this.reloadTabsData();
      },
    },
    pei: {
      deep: true,
      handler(newValue) {
        if (!newValue) return;

        this.reloadTabsData();
      },
    },
    programServiceAreaId: {
      immediate: true,
      handler(newValue) {
        if (!newValue) return;

        this.reloadTabsData();
      },
    },
  },
  methods: {
    ...mapActions(['loadTabsData', 'fetchGoalsTabInfo']),
    saveActiveTab() {
      this.$refs[this.tabRefs[this.activeTab]].save();
    },
    async handleSwitchTab(newTabIndex, oldTabIndex, event) {
      let isValid = true;

      if (this.tabPendingChanges[oldTabIndex]) {
        event.preventDefault();
        const isNeedSave = await this.ShowCancelModal(
          'Confirmación',
          `El sistema encontró que tiene datos sin guardar en esta parte, ¿desea guardar la información antes de continuar?`
        );

        if (isNeedSave) {
          isValid =
            isValid && (await this.$refs[this.tabRefs[oldTabIndex]].save());
        }

        this.tabPendingChanges[oldTabIndex] = !isValid;
      }
      const tabToMove = isValid ? newTabIndex : oldTabIndex;
      this.setActive(tabToMove);
    },
    setPendingChange(hasPendingChange) {
      this.tabPendingChanges[this.activeTab] = hasPendingChange;
    },
    initTabsMetadata() {
      this.tabRefs[TABS.ResumenResultados] = 'resultSummaryRef';
      this.tabRefs[TABS.SubAreas] = 'subAreasRef';
      this.tabRefs[TABS.Fortalezas] = 'StrenghtSelection';
      this.tabRefs[TABS.Necesidades] = 'necessitiesRef';
      this.tabRefs[TABS.FortalezasNecesidades] = 'skillsRef';
      this.tabRefs[TABS.MetasObjetivos] = 'goalsListRef';
      this.tabRefs[TABS.MetasObjetivosV2] = 'goalsListV2Ref';
      this.tabRefs[TABS.ServiciosCompensatorios] = 'RefServiceCompensation';
      this.tabRefs[TABS.Procedimientos] = 'procedureRef';
    },
    async reloadTabsData() {
      if (
        !this.programServiceAreaId ||
        !this.selectedArea?.id ||
        !this.pei?.studentSieId ||
        !this.selectedPeiId
      )
        return;

      await this.loadTabsData({
        peiId: this.selectedPeiId,
        peiGgradeId: this.pei.gradeId,
        studentSieId: this.pei.studentSieId,
        academicYearId: this.pei.configAcademicYearId,
        programServiceAreaId: this.programServiceAreaId,
        selectedArea: this.selectedArea,
      });
    },
    setValueMaster() {
      if (this.isReadOnly) {
        return;
      }
      this.editSelectionTeacher = true;
    },
    setActive(tabId) {
      this.activeTab = tabId;
      this.$refs.qTab?.setActiveTabByTabindex(tabId);
    },
    // AG-05 -- "Meta + Objetivos encadenados": segundo parámetro opcional `onCreated`, usado
    // SOLO por el flujo de "Meta con Asistente IA" (ver GoalsManager.vue/SubAreaNecessity.vue)
    // para recibir de vuelta la Meta recién creada -- con su `peiProgramServiceGoalId` REAL,
    // que este endpoint SÍ devuelve (PeiEngine.AddAcademicAreaGoalAsync ya lo pobla) -- y así
    // poder identificar esa Meta en la lista tras el refetch sin depender de un match de texto.
    // Un guardado manual normal ("Añadir Meta"/"Añadir Nueva Meta") sigue funcionando idéntico
    // a como estaba: no pasa `onCreated`, así que este bloque simplemente no hace nada extra.
    async handleCreateGoal(goal, onCreated) {
      // 15 sep -- `onCreated` ahora se invoca en el `finally`, no solo tras el `try` exitoso,
      // para que SIEMPRE se llame una vez (con datos si hubo éxito, sin nada si falló). Antes,
      // si el POST fallaba, `onCreated` nunca se llamaba -- cualquier código que esperara esa
      // señal (ver GoalsManager.vue/SubAreaNecessity.vue -> saveGoalHandler, usado para saber
      // cuándo el guardado real de "Meta con Asistente IA" terminó y así apagar el loading del
      // modal de IA) se quedaba esperando para siempre.
      let response;
      try {
        const payload = {
          ...goal,
          goalId: 0,
          peiId: this.selectedPeiId,
          peiProgramServiceGoalId: 0,
          programServiceAreaId: parseInt(this.programServiceAreaId),
          spaLongDescription: goal.description,
          spaShortDescription: goal.description,
          areaId: parseInt(this.selectedArea.id),
          strenghtsAndNecessities: goal.strenghtsAndNecessities,
          peiProgramServiceObjective: [],
        };

        response = await this.$ApiPost(`api/pei/AddProgramServiceGoal`, payload);

        this.ShowToast('', 'Meta creada exitosamente', 'success');
        await this.fetchGoalsTabInfo();
      } catch (err) {
        this.ShowToast(err, DEFAULT_MESSAGE_ERROR, 'error');
      } finally {
        if (typeof onCreated === 'function') {
          onCreated(response?.data);
        }
      }
    },
    // 15 sep -- nuevo parámetro opcional `onCreated`, mismo patrón que handleCreateGoal de
    // arriba: es la señal real de que el POST + refetch de "Añadir Objetivo" terminó (éxito o
    // error). Lo usa "Objetivo con Asistente IA" (ver SubAreaGoalCallout.vue ->
    // handleAiObjectiveSelected/handleSave) para saber cuándo apagar el loading del modal de IA
    // en vez de cerrarlo de inmediato sin esperar el guardado real. Un guardado manual normal
    // ("Añadir Objetivo") sigue funcionando idéntico: no pasa `onCreated`, así que este cambio
    // no hace nada extra en ese caso.
    async handleAddObjetive(objetive, onCreated) {
      try {
        await this.$ApiPost(`api/pei/AddProgramServiceObjective`, objetive);
        this.ShowToast('', 'Objetivo creado exitosamente', 'success');

        await this.fetchGoalsTabInfo();
      } catch (err) {
        this.ShowToast(err, DEFAULT_MESSAGE_ERROR, 'error');
      } finally {
        if (typeof onCreated === 'function') {
          onCreated();
        }
      }
    },
    // AG-05 -- mismo patrón de Tab3.vue (mounted(), parámetro EnableAiAssistantPei):
    // primero intenta con academicYearId (por si el parámetro está configurado por año
    // académico), y si no aparece, reintenta sin academicYearId por si se creó como
    // parámetro global.
    async loadAiAssistantFlag() {
      const academicYearId = store.getters.getPeiInfo?.academicYearId;
      const { data } = await getSysparameterByNames({
        parameterNames: ['EnableAiAssistantPei'],
        academicYearId,
      });

      const aiParam = data.find((x) => x.name == 'EnableAiAssistantPei');
      if (aiParam) {
        this.aiAssistantParamEnabled = aiParam.staticValue == 'true';
      } else {
        const { data: globalData } = await getSysparameterByNames({
          parameterNames: ['EnableAiAssistantPei'],
        });
        this.aiAssistantParamEnabled =
          globalData.find((x) => x.name == 'EnableAiAssistantPei')?.staticValue ==
          'true';
      }
    },
    async handleUpdateObjetive(objetive) {
      try {
        await this.$ApiPost(`api/pei/AddProgramServiceObjective`, objetive);
        this.ShowToast('', 'Objetivo actualizado exitosamente', 'success');

        await this.fetchGoalsTabInfo();
      } catch (err) {
        this.ShowToast(err, DEFAULT_MESSAGE_ERROR, 'error');
      }
    },
    async handleDeleteObjetive(objetiveId) {
      try {
        await this.$ApiDelete(
          `api/pei/DeleteProgramServiceObjective/${objetiveId}`
        );
        this.ShowToast('', 'Objetivo eliminado exitosamente', 'success');

        await this.fetchGoalsTabInfo();
      } catch (err) {
        this.ShowToast(err, DEFAULT_MESSAGE_ERROR, 'error');
      }
    },
    async handleDeleteGoal(goal) {
      try {
        await this.$ApiDelete(
          `api/pei/DeleteProgramServiceGoal/${goal.peiProgramServiceGoalId}`,
          goal
        );
        this.ShowToast('', 'Meta eliminada exitosamente', 'success');

        await this.fetchGoalsTabInfo();
      } catch (err) {
        this.ShowToast(err, DEFAULT_MESSAGE_ERROR, 'error');
      }
    },
    async handleUpdateGoal(goal) {
      try {
        await this.$ApiPost(`api/pei/AddProgramServiceGoal`, goal);
        this.ShowToast('', 'Meta actualizada exitosamente', 'success');

        await this.fetchGoalsTabInfo();
      } catch (err) {
        this.ShowToast(err, DEFAULT_MESSAGE_ERROR, 'error');
      }
    },
    async handleDeleteGoalNecessity(data) {
      try {
        await this.$ApiPut(`api/pei/deletegoalnecessity`, data);
        await this.fetchGoalsTabInfo();
      } catch (err) {
        this.ShowToast(err, DEFAULT_MESSAGE_ERROR, 'error');
      }
    },
    async handleUpdateSkills(data) {
      try {
        await this.$ApiPut(`api/pei/goalskills`, data);
        await this.fetchGoalsTabInfo();

        this.ShowToast('', 'Datos actualizados correctamente', 'success');
      } catch (err) {
        this.ShowToast(err, DEFAULT_MESSAGE_ERROR, 'error');
      }
    },
    async onLoadComponent() {
      const peiResponse = await this.$ApiGet(
        `/api/pei/getpei?peiId=${this.selectedPeiId}`
      );
      this.pei = peiResponse.data;

      // Get teachers
      const teachersFromBE = await this.$ApiGet('/api/pei/getteachertypes');
      this.teachers = teachersFromBE.data;

      const { programservicearea } = this.$root.$route.query;
      if (programservicearea) {
        const { data: programServiceAreaObj } = await this.$ApiGet(
          `/api/pei/getareafromservice/${programservicearea}`
        );
        if (programServiceAreaObj) {
          this.selectedArea = {
            id: programServiceAreaObj.areaId,
            name: programServiceAreaObj.areaName,
            value: programServiceAreaObj.disciplineTypeId,
          };

          if (programServiceAreaObj.teacherTypeId) {
            let teacher = this.teachers.find(
              (teacher) => teacher.id == programServiceAreaObj.teacherTypeId
            );

            if (teacher) {
              this.selectedTeacher = {
                id: teacher.id,
                name: teacher.name,
              };
            }
          }

          this.others = programServiceAreaObj.description;
        }
      }

      const { data: areasForPei } = await this.$ApiGet(
        `/api/pei/getassociatedpeiprogramserviceareas?peiId=${this.selectedPeiId}`
      );
      if (!areasForPei) return;

      const { data: allAreasFromBE } = await this.$ApiGet(
        `/api/pei/getpeiprogramserviceareas?peiId=${this.selectedPeiId}`
      );
      if (!allAreasFromBE) return;

      // Filter the areas to show in the dropdown: not associated to current Pei
      this.areas = allAreasFromBE.filter((area) => {
        const isInPei = (element) => element.areaId == area.id;
        return (
          areasForPei.findIndex(isInPei) == -1 ||
          area.id == commonValues.PROGRAM_AREAS.OTROS
        ); // 'Otros' puede repetirse
      });
    },
    goToAddProgramService() {
      this.$router.push('/pei/addprogramservice');
      Object.assign(this.$data, initialState());
      this.onLoadComponent();
    },
    async canShowValidation() {
      const { data } = await this.$ApiGet(
        `/api/pei/getlaststatuspei/${this.selectedPeiId}`
      );
      this.canShowValidationCompensatory = data;
    },
    async onEditTeacherDropdown(item) {
      let response = await this.$ApiPost(
        `api/pei/setteachertypepeiprogramserviceareas/${this.programServiceAreaId}/${item.id}`
      );
      if (response.status == 200) {
        this.ShowToast(
          this.resource('R03200110'),
          this.resource('R03200109'),
          'success'
        );
      }
      this.editSelectionTeacher = false;
    },
    cleanFields() {
      this.others = '';
      this.selectedTeacher = null;
    },
    async saveTextOthers() {
      let response = await this.$ApiPost(
        `api/pei/setothertextpeiprogramserviceareas/${this.programServiceAreaId}/${this.others}`
      );
      if (response.status == 200) {
        this.ShowToast(
          this.resource('R03200110'),
          this.resource('R03200109'),
          'success'
        );
      }
      this.editTextOthers = false;
    },
    async saveProgramServiceArea(e) {
      e.preventDefault();
      const isValid = await this.$refs.addProgramServiceValidator.validate();
      if (!isValid) return;

      const programServiceData = {
        UserId: store.state.userProfile.sub,
        PeiId: this.selectedPeiId,
        AreaId: this.selectedArea.id,
        Description: this.others != '' ? this.others : null,
        PeiTeacherTypeId: this.selectedTeacher
          ? parseInt(this.selectedTeacher.id, 32)
          : null,
      };

      try {
        const { data } = await this.$ApiPost(
          '/api/pei/postpeiprogramserviceareas',
          programServiceData
        );
        this.submittedAreaId = data?.id;
        this.ShowToast(
          this.resource('R03200110'),
          this.resource('R03200109'),
          'success'
        );

        await this.getStudentReferralAdmissionInfo();
        this.verifyAndSetActiveTab();
      } catch (err) {
        this.ShowToast('', err?.response?.data?.message, 'error');
      }
    },
    async saveGoalsAndObjectivesFlag() {
      this.$store.commit(
        `$_user/${types.SET_USER_GOALS_AND_OBJECTIVES_FLAG}`,
        this.isGoalsAndObjectivesDesignerEnabled
      );
      await updateGoalsObjectivesFlag(this.isGoalsAndObjectivesDesignerEnabled);
    },
    async saveGoalsV2Flag() {
      await updateGoalsV2Flag(this.selectedPeiId, this.isGoalsV2Enabled);
    },
    async getStudentReferralAdmissionInfo() {
      if (!this.selectedArea) return;

      const { data } = await _getStudentReferralAdmissionInfo(
        this.pei.studentSieId,
        this.selectedArea.value,
        this.pei.configAcademicYearId
      );

      this.referralAdmissionInfo =
        typeof data === 'string' && !data ? null : data;
      this.$nextTick(() =>
        this.$refs[this.tabRefs[TABS.ResumenResultados]]?.loadData()
      );
    },
    serviceIsterapy(id) {
      return Object.values(thrpiesServiceCode).includes(id);
    },
    async updatePendingChangeToReadInProgramServiceArea() {
      try {
        if (!this.programServiceAreaId) return;

        await this.$ApiPut(
          `api/pei/updatependingchangestoreadinprogramservicearea/${this.programServiceAreaId}`
        );
      } catch (err) {
        this.ShowToast(err, DEFAULT_MESSAGE_ERROR, 'error');
      }
    },
    verifyAndSetActiveTab() {
      const defaultTab = this.showResultSummary
        ? TABS.ResumenResultados
        : TABS.SubAreas;

      let tabRoute = this.$root.$route.query.tab;

      switch (this.$root.$route.query.tab) {
        case TabAliasEnum.SubAreas:
          tabRoute = TABS.SubAreas;
          break;
        case TabAliasEnum.Procedures:
          tabRoute = TABS.Procedimientos;
          break;
        case TabAliasEnum.ResultSummary:
          tabRoute = TABS.ResumenResultados;
          break;
        case TabAliasEnum.Strengths:
          tabRoute = this.isGoalsAndObjectivesDesignerEnabled
            ? TABS.FortalezasNecesidades
            : TABS.Fortalezas;
          break;
        case TabAliasEnum.Needs:
          tabRoute = this.isGoalsAndObjectivesDesignerEnabled
            ? TABS.FortalezasNecesidades
            : TABS.Necesidades;
          break;
        case TabAliasEnum.Goals:
          tabRoute = this.isGoalsAndObjectivesDesignerEnabled
            ? TABS.MetasObjetivosV2
            : TABS.MetasObjetivos;
          break;
        default:
          tabRoute = defaultTab;
          break;
      }

      this.setActive(tabRoute);
    },
    async fetchGoalsSectionVisbility(peiId) {
      const { data } = await this.$ApiGet(
        `api/pei/objetivessectionvisibility/${peiId}`
      );
      if (this.canShowGoalsV2Switch) {
        this.showAdequacy = data.showAdequacy;
        this.isGoalsV2Enabled = data.isGoalsV2Enabled;
        this.showObjetivesSectionInTherapy = data.inTherapy;
        this.showObjetivesSectionInNonTherapy = data.inNonTherapy;
      }
      this.isGoalLevelsEnabled = data.isGoalLevelsEnabled;
    },
  },
  async mounted() {
    await this.onLoadComponent();
    this.initTabsMetadata();
    if (this.canShowDesginerSwitch) {
      this.isGoalsAndObjectivesDesignerEnabled = this.$store.getters[
        '$_user/goalsAndObjectivesFlag'
      ];
    }

    // AG-05 -- el ícono/botón "Objetivo con Asistente IA" solo aplica dentro del Diseñador
    // de Metas y Objetivos v2, así que el sysparam solo se consulta cuando ese visor está
    // activo (evita una llamada de red innecesaria para quien sigue en la vista v1).
    if (this.isGoalsAndObjectivesDesignerEnabled) {
      await this.loadAiAssistantFlag();
    }

    await this.getStudentReferralAdmissionInfo();
    this.updatePendingChangeToReadInProgramServiceArea();
    this.canShowValidation();
    await this.fetchGoalsSectionVisbility(this.selectedPeiId);
    this.verifyAndSetActiveTab();
  },
};
</script>
<style scoped>
.bg-gray {
  background: #fafbfa 0% 0% no-repeat padding-box !important;
}
.thead-property {
  border-radius: 5px 5px 0px 0px !important;
}

.action-div {
  cursor: pointer;
}

.action-button-position {
  margin-top: 2.7rem !important;
}

.area-label {
  background: #d3e0d9;
  border: 1px solid #aabbb4;
  border-radius: 26px;
  padding: 5px 15px;
  font-weight: bold;
}

.toggle-position {
  margin-bottom: -26px;
}
.collapse-item-v2__container {
  background-color: #f5f5f5;
}

.tab-item {
  background-color: #f2f2f2;
}
.nav-item-Sub-menu {
  width: 33.2%;
  height: 55px;
}
.color-red {
  color: red;
}
</style>
